import { S as y } from "./Select-CfkMpX3N.js";
import { I as g } from "./Input-yplyeePD.js";
import { i as S } from "./utils-CMsllPx8.js";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { ao as p, m as c, c as r, e as n, g as m, h as L, w as W, F as w, p as N, t as O, f as V, k as f, l as F, n as C, an as E } from "./define-element-XpjsV6s1.js";
const M = ["value"], R = {
  key: 0,
  class: "error"
}, v = [
  { value: "Friend/Colleague", label: "Friend / Family / Colleague", noteLabel: "Please share their name" },
  { value: "Restaurant/Shop", label: "Restaurant / Shop", noteLabel: "Which restaurant or shop?" },
  { value: "Hotel/Other Winery", label: "Hotel / Winery", noteLabel: "Which hotel or winery?" },
  { value: "Event/Tasting", label: "Event / Tasting", noteLabel: "Which event or tasting?" },
  { value: "Press/Website", label: "Press / Website", noteLabel: "Which publication or website?" },
  { value: "Social Media", label: "Social Media", noteLabel: "Which social site or app?" },
  { value: "Other", label: "Other", noteLabel: "Please let us know whom we may thank!" }
], T = {
  __name: "ReferralNote",
  props: /* @__PURE__ */ E({
    invalid: {
      type: Boolean,
      default: !1
    },
    // Per-client override (e.g. a one-off list for a single account) — set
    // via the referral-options attribute on <offset-checkout>/
    // <offset-event-checkout>, which passes it down here as-is. Left
    // undefined, every account keeps the generic DEFAULT_OPTIONS list above.
    // A custom-element attribute always arrives as a plain string (Vue's
    // custom-element bridge only coerces Number/Boolean props, not
    // Array/Object — see useConfig()'s identical configOverride handling),
    // so this accepts either the already-resolved array or that raw JSON.
    options: {
      type: [Array, String],
      default: () => v
    }
  }, {
    source: {
      type: String,
      default: ""
    },
    sourceModifiers: {},
    note: {
      type: String,
      default: ""
    },
    noteModifiers: {}
  }),
  emits: ["update:source", "update:note"],
  setup(s) {
    const o = p(s, "source"), i = p(s, "note"), l = s, u = c(() => {
      if (typeof l.options == "string")
        try {
          return JSON.parse(l.options);
        } catch (a) {
          return console.error("Failed to parse ReferralNote options as JSON", a), v;
        }
      return l.options;
    }), h = c(
      () => {
        var a;
        return (a = u.value.find((e) => e.value === o.value)) == null ? void 0 : a.noteLabel;
      }
    );
    function b(a) {
      const e = a.target;
      setTimeout(() => {
        var d;
        const t = (d = e.parentElement) == null ? void 0 : d.querySelector(".offset-input input");
        t && t.focus();
      }, 300);
    }
    return (a, e) => (r(), n("div", {
      class: C(["offset-referral-note", a.$attrs.required != null ? "is-required" : ""])
    }, [
      e[3] || (e[3] = m("h3", null, "Whom may we thank for the introduction?", -1)),
      L(y, {
        modelValue: o.value,
        "onUpdate:modelValue": e[0] || (e[0] = (t) => o.value = t),
        "aria-label": "Whom may we thank for the introduction?",
        invalid: l.invalid,
        onChange: b
      }, {
        default: W(() => [
          e[2] || (e[2] = m("option", {
            value: "",
            disabled: "",
            selected: ""
          }, "Select an option", -1)),
          (r(!0), n(w, null, N(u.value, (t) => (r(), n("option", {
            key: t.value,
            value: t.value
          }, O(t.label), 9, M))), 128))
        ]),
        _: 1,
        __: [2]
      }, 8, ["modelValue", "invalid"]),
      l.invalid && V(S)(o.value) ? (r(), n("div", R, " This field is required ")) : f("", !0),
      o.value ? (r(), F(g, {
        key: 1,
        floating: !0,
        modelValue: i.value,
        "onUpdate:modelValue": e[1] || (e[1] = (t) => i.value = t),
        label: h.value
      }, null, 8, ["modelValue", "label"])) : f("", !0)
    ], 2));
  }
}, x = /* @__PURE__ */ k(T, [["__scopeId", "data-v-d8a2757b"]]);
export {
  x as R
};
